<app-form-input [parentForm]="parentForm" [disabled]="disabled" [value]="oui?.nbCandidat" [label]="step2.nbCandidat"
	[type]="'number'" [rule]="'min_0|max_999|required'" [errorMessage]="{'required' : 'ctr_1079'}"
	[name]="getUid() + '_SepAtt_nbCandidat'">
</app-form-input>
<!--886-->
<app-form-input
	[parentForm]="parentForm"
	
	[disabled]="disabled"
	[value]="oui?.criteres"
	
	[label]="step2.criteres"
	[type]="'text'"
	[rule]="'minSize_3|maxSize_1000|required'"
	[errorMessage]="{'required' : 'ctr_1080'}"
	[name]="getUid() + '_SepAtt_criteres'"
>
</app-form-input>